<template>
  <div v-loading="loading"  element-loading-background="rgba(0, 0, 0, 0.8)">
    <div style="border-bottom: 1px solid #c2b8b89c">
      <el-badge class="item" style="margin-left: 15px;">
        <img src="../../../img/tupian.png" class="el-icon-tickets  my-icon" @click.stop="allLabelEvt()" id="icon"
          alt="">
        <sup  class="sup" v-if="Object.keys(this.data).length ==0 ?false :true">{{Object.keys(this.data).length}}</sup>
      </el-badge>
      <div>
        <span class="span_box" v-if="tableData == ''  ? false :true" ></span>
        <span class="span_box_two" v-if="tableData == ''  ? false :true" ></span>
        <div :class="header == true ? 'block' : 'block1'">
          <div class="pagination_box">
            <el-input v-model="data.paginationInput" style="width: 50px" size="mini" @change="limitEvt"
              placeholder="To"></el-input>
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
              :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5"
              :show-total="showTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="search_box " v-show="showForm" ref="myDiv" id="form">
      <span @click="cleanUpEvt" class="all_text">All</span>
      <el-input v-model=" data.remtInput    " style="width: 127px;margin-top: 20px;" size="mini" placeholder="备注"
        clearable @clear="clearEvt1"></el-input>
      <el-input v-model="data.authorIdInput" style="width: 127px;margin-top: 5px;" size="mini" placeholder="昵称"
        clearable @clear="clearEvt2"></el-input>
      <el-input v-model="data.localInput" style="width: 127px;margin-top: 5px;" size="mini" placeholder="初次登录地"
        clearable @clear="clearEvt3"></el-input>
      <el-date-picker v-model="data.value2" style="width: 300px;margin-top: 5px; " type="daterange"
        :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator=""
        start-placeholder="初次登录开始日期" end-placeholder="初次登录结束日期" align="right">
      </el-date-picker>
      <el-date-picker v-model="data.value1" style="width: 300px;margin-top: 5px;" type="daterange"
        :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" value-format="yyyyMMdd" range-separator=""
        start-placeholder="会员开始日期" end-placeholder="会员结束日期" align="right">
      </el-date-picker>
      <el-input v-model="data.last_login" style="width: 127px;margin-top: 5px;" @change="getList" size="mini"
        placeholder="最近登录地" clearable @clear="clearEvt4"></el-input>
      <el-dropdown class="num_box" @command="effectiveEvt">
        <el-button type="primary" size="mini" :class="effectiveName !== '有效性' ? 'vip-button' : ''">
          {{ effectiveName }}<i class="el-icon-arrow-down el-icon--right"></i>
          <i class="el-icon-circle-close  clear_ev" v-if="effectiveName !== '有效性' " @click="clearEvt5"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">&nbsp;是&nbsp; </el-dropdown-item>
          <el-dropdown-item command="2">&nbsp;否&nbsp; </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="num_box" @command="levelEvt">
        <el-button type="primary" size="mini" :class="levelName !== '等级' ? 'vip-button' : ''">
          {{ levelName }}<i class="el-icon-arrow-down el-icon--right"></i>
          <i class="el-icon-circle-close clear_ev" v-if="levelName !== '等级'" @click="clearEvt6"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">普通账号</el-dropdown-item>
          <el-dropdown-item command="2">内部账号</el-dropdown-item>
          <el-dropdown-item command="5">客户账号</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="num_box" @command="RechargeEvt">
        <el-button type="primary" size="mini" :class="RechargeName !== '点数情况' ? 'vip-button' : ''">
          {{ RechargeName }}<i class="el-icon-arrow-down el-icon--right"></i>
          <i class="el-icon-circle-close   clear_ev" v-if="RechargeName !== '点数情况'" @click="clearEvt7"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">消费中</el-dropdown-item>
          <el-dropdown-item command="2">消费完毕</el-dropdown-item>
          <el-dropdown-item command="3">未充值</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="num_box" @command="vipEvt">
        <el-button type="primary" size="mini" clearable :class="vipName !== '会员情况' ? 'vip-button' : ''">
          {{ vipName }}<i class="el-icon-arrow-down el-icon--right"></i>
          <i class="el-icon-circle-close  clear_ev" v-if="vipName !== '会员情况' " @click="clearEvt8"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">会员中</el-dropdown-item>
          <el-dropdown-item command="2">过期会员</el-dropdown-item>
          <el-dropdown-item command="3">未入会</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="num_box" @command="registerEvt">
        <el-button type="primary" size="mini" :class="registerName !== '注册来源' ? 'vip-button' : ''">
          {{ registerName }}
          <i class="el-icon-arrow-down el-icon--right"></i>
          <i class="el-icon-circle-close  clear_ev" v-if="registerName !== '注册来源' " @click="clearEvt9"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">Facebook</el-dropdown-item>
          <el-dropdown-item command="2">Google</el-dropdown-item>
          <el-dropdown-item command="3">QQ</el-dropdown-item>
          <el-dropdown-item command="4">微信</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="clear" id="close-btn">
        <span @click="OK_Pop">OK</span>
      </div>
      </el-dropdown>

    </div>
    <div>
        
      <div style="overflow: auto;margin-top: 50px;overflow: unset">
        <el-table ref="sortTable" :data="tableData" :cell-style="rowStyle" :summary-method="getSummaries" height="55%"
          @sort-change="sortChangeEvt" show-summary style="width: 100%; margin-top: 20px; overflow: none">
          <!-- <el-table-column type="vlo" width="55"> </el-table-column> -->
          <el-table-column sortable="custom" prop="remark" label="备注" width="220" align="center" fixed>
            <template slot-scope="props">
              <div class="notes_box">
                <el-input ref="editInput" v-if="props.row.id === editShowInp" v-model="props.row.remark"
                  @keyup.enter.native="determineEvt" @blur="editInpBlurEvt" placeholder="请输入内容"></el-input>
                <div class="name_box" @click="editShowEvt(props.row, 'remark')" v-else>
                  <span style="height: 72px; line-height: 72px">{{
                    props.row.remark
                    }}</span>
                  <i class="el-icon-edit"></i>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="nickname" width="120" label="昵称" height="250" fixed align="left">
          </el-table-column>
          <el-table-column prop="" width="80" label="头像" height="250" fixed align="left">
            <template slot-scope="props">
              <el-avatar :src="props.row.header_img"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="level" width="120" label="等级" align="left">
            <template slot-scope="props">
              <div>
                <el-dropdown trigger="click" @command="tableLevelEvt">
                  <span class="el-dropdown-link" @click="activeTextEvt(props.row)"
                   :style="{  color: props.row.level === '普通账号' ? '#d1d1d1' : props.row.level === '客户账号' ? '#409eff' : '#333'}">
                    {{ props.row.level }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown"  >
                    <el-dropdown-item :disabled="props.row.level == '普通账号'" command="1">普通账号</el-dropdown-item>
                    <el-dropdown-item :disabled="props.row.level == '内部账号'" command="2">内部账号</el-dropdown-item>
                    <el-dropdown-item :disabled="props.row.level == '客户账号'" command="5">客户账号</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="member" width="120" label="会员情况" align="left">

          </el-table-column>
          <el-table-column sortable="custom" prop="recharge" label="点数情况" width="120" align="left">
            <template slot-scope="props">
              <span :style="{color: props.row.recharge == '未充值' ? '#d1d1d1' : props.row.recharge !== '未充值' ? '#409eff' : '#333', }"> {{props.row.recharge}}</span>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="total_amount" width="120" label="总消费金额" align="center">
          </el-table-column>

          <el-table-column sortable="custom" prop="total_cost" width="120" label="会员金额" align="center">
            <template slot-scope="props">
              <span :style="{color: props.row.total_cost == 0 ? '#d1d1d1' : '#333', }"> {{props.row.total_cost}}</span>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" width="120" prop="amount" label="点数金额" align="center">
          </el-table-column>
          <el-table-column sortable="custom" prop="review" label="参考图查看" width="120" align="center">
          </el-table-column>
          <el-table-column sortable="custom" prop="refer_tag" label="参考图标签" width="120" align="center">
          </el-table-column>
          <el-table-column sortable="custom" prop="download" label="会员下载" width="120" align="center">
          </el-table-column>
          <el-table-column sortable="custom" prop="buy_dang" label="点数下载" width="120" align="center">
          </el-table-column>
          <el-table-column sortable="custom" prop="social_type" label="注册来源" width="120" align="left">
          </el-table-column>
          <el-table-column sortable="custom" prop="vip_start" label="会员开始" width="120" align="left">
            <template slot-scope="props">
              <div>
                <el-tooltip class="item" effect="dark" :content="props.row.vip_start" placement="bottom">
                  <span>{{ props.row.vip_start.substring(0, 11) }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="expire_time" label="会员到期" width="120" align="left">
            <template slot-scope="props">
              <div>
                <el-tooltip class="item" effect="dark" :content="props.row.expire_time" placement="bottom">
                  <span>{{ props.row.expire_time.substring(0, 11) }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="first_local" label="初次登录地" width="120" align="left">
            <template slot-scope="props">
              <div>
                <el-tooltip class="item" effect="dark" :content="props.row.first_local" placement="bottom">
                  <span>{{ props.row.first_local.substring(0, 6) }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="create_time" label="初次登录" width="120" align="left">
            <template slot-scope="props">
              <div>
                <el-tooltip class="item" effect="dark" :content="props.row.create_time" placement="bottom">
                  <span>{{ props.row.create_time.substring(0, 11) }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="last_local" label="最近登陆地" width="120" align="left">
            <template slot-scope="props">
              <div>
                <el-tooltip class="item" effect="dark" :content="props.row.last_local" placement="bottom">
                  <span>{{ props.row.last_local.substring(0, 6) }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="update_time" label="最近使用时间" width="140" align="left">
            <template slot-scope="props">
              <div>
                <el-tooltip class="item" effect="dark" :content="props.row.update_time" placement="bottom">
                  <span>{{ props.row.update_time.substring(0, 11) }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="recharge_dang" label="充值点数" width="120" align="left">
          </el-table-column>
          <el-table-column sortable="custom" prop="used_dang" label="消费点数" width="120" align="left">
          </el-table-column>
          <el-table-column sortable="custom" prop="balance_dang" label="剩余点数" width="120" align="left">
          </el-table-column>
          <el-table-column sortable="custom" prop="is_active" label="有效性" width="120" align="left">
            <template slot-scope="props">
              <div>
                <el-dropdown trigger="click" @command="activeEvt">
                  <span class="el-dropdown-link" @click="activeTextEvt(props.row)">
                    {{ props.row.is_active
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :disabled="props.row.is_active == '有效'" command="1">有效</el-dropdown-item>
                    <el-dropdown-item :disabled="props.row.is_active == '无效'" command="2">无效</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="right" label="操作" align="left"> </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="deleteVisible" width="30%">
      <span style="font-size: 14px">请确认是否切换账户！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">否</el-button>
        <el-button type="primary" @click="confirmDelete">是</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getUserListApi, editListApi } from "../../../apis/user/index";
  export default {
    data() {
      return {
        header: true,
        src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",

        //备注
        remtInput: "",
        authorIdInput: "",
        localInput: "",
        last_login: "",
        //分页输入框数据
        paginationInput: 10,
        currentPage1: 1,
        //分页总数据
        total: null,
        pickerOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "本周",
              onClick(picker) {
                const current = new Date();
                let nowDayOfWeek = current.getDay();
                if (nowDayOfWeek === 0) nowDayOfWeek = 7;
                const dayNum = 1 * 24 * 60 * 60 * 1000;
                const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
                const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
                picker.$emit("pick", [firstDate, lastDate]);
              },
            },
            {
              text: "当月",
              onClick(picker) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth();
                let thisMonthStartDate = new Date(year, month, 1);
                let thisMonthEndDate = new Date(year, month + 1, 0);
                picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
              },
            },
            {
              text: "当年",
              onClick(picker) {
                var tYear = new Date().getFullYear();
                var startTime = new Date(tYear, 0, 1); //当前年第一天
                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                picker.$emit("pick", [startTime, endTime]);
              },
            },
            {
              text: "昨天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                picker.$emit("pick", [start, start]);
              },
            },
            {
              text: "上周",
              onClick(picker) {
                const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
                let nowDayOfWeek = current.getDay();
                let diffToMonday =
                  current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
                const firstDate = new Date(current.setDate(diffToMonday));
                const lastDate = new Date(current.setDate(diffToMonday + 6));
                picker.$emit("pick", [firstDate, lastDate]);
              },
            },
            {
              text: "上月",
              onClick(picker) {
                var now = new Date();
                var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                var ed = new Date(now.getFullYear(), now.getMonth(), 0);
                picker.$emit("pick", [fd, ed]);
              },
            },
            {
              text: "去年",
              onClick(picker) {
                var tYear = new Date().getFullYear() - 1;
                var startTime = new Date(tYear, 0, 1);
                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                picker.$emit("pick", [startTime, endTime]);
              },
            },
          ],
        },
        value1: "",
        value2: "",
        levelName: "等级",
        adminuser: null,
        vipName: "会员情况",
        member: null,
        effectiveName: "有效性",
        okAndNo: null,
        RechargeName: "点数情况",
        recharge: null,
        registerName: "注册来源",
        laiyuan: null,
        input: "",
        editShowInp: null,
        editName: null,
        tableData: [],
        totalRow: null,
        //排序
        order: null,
        orField: null,
        activeId: null,
        deleteVisible: false,
        showForm: false,
        data: {},
        num: null,
        count: 0,
        pagefenye: false,//点击分页 滚动条为0
        loading: false,

      };
      dataLength: 0
    },
    created() {
      getUserListApi().then((res) => {
        this.tableData = res.data;
        this.paginationInput = res.limit;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
      });
      //监听鼠标按下抬起事件
      window.addEventListener("keydown", this.handKeyCode, true);
      window.addEventListener('keyup', this.handKeyEvt);
    },
    beforeDestroy() {
      // 在组件生命周期结束的时候销毁
      window.removeEventListener("keydown", this.handKeyCode, false);
      window.removeEventListener("keyup", this.handKeyEvt, false);
    },
    mounted() {
      //监听页面滚动条事件
      window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    },
    methods: {

      //分页只显示前三页加总数
      showTotal(total) {
        return `共 ${total} 页`;
      },
      //点击icon图标出现表单  点击其他区域隐藏表单
      allLabelEvt() {
        const icon = document.getElementById('icon');
        const form = document.getElementById('form');
        form.style.display = 'block';
        form.style.display = 'flex';
        // 点击图标显示表单
        icon.addEventListener('click', function () {
          form.style.display = 'block';
          form.style.display = 'flex';
        });
        // 点击表单外部隐藏表单
        document.addEventListener('click', function (event) {
          if (!form.contains(event.target) && event.target !== icon) {
            form.style.display = 'none';
          }
        });
      },
      //按下键盘事件
      handKeyCode(e) {
        e = e || window.event;
        if (e.keyCode == 78) {
          this.cleanUpEvt()
        }
        if (e.keyCode == 70) {
          this.count++;
          if (this.count == 1) {
            this.showForm = true
          } else {
            this.showForm = false
          }
          setTimeout(() => {
            this.count = 0;
          }, 500);
        }
      },

      limitEvt() {
        this.getList();
      },
      //滑动事件
      imgScrollEvt(e) {
        var e =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          e ||
          document.body.scrollTop;
        //点击分页 滚动条为0
        if (this.pagefenye == true) {
          e.scrollTop = 0;
          this.pagefenye = false
          return
        }
        var scrollTop = e.target.scrollTop;
        let scrollStep = scrollTop - this.oldScrollTop;
        this.oldScrollTop = scrollTop;
        var scrollLeft = e.target.scrollLeft;
        let scrollLeftStep = scrollLeft - this.oldScrollLeft;
        this.oldScrollLeft = scrollLeft;

        if (scrollLeft > 0 && scrollTop == 0) {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
          return;
        }
        if (scrollTop <= 0) {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
          return;
        }
        if (scrollStep == 0) {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
          return;
        }
        if (scrollStep < 0) {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
        } else {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
        }
      },
      //分页
      handleCurrentChange(res) {
        this.loading = true
          setTimeout(()=>{
           this.getList()
           this.loading = false
          },100)
      },
      //
      rowStyle({ row, column, rowIndex, columnIndex }) {
        if (column.label == "等级") {
          return {};
        } else if (column.label == "昵称") {
          return {};
        }
      },
      //列表排序
      sortChangeEvt(row) {
        if (row.order == "ascending") {
          this.order = "asc";
        } else if (row.order == "descending") {
          this.order = "desc";
        }
        this.orField = row.prop;
        this.getList();
      },
      //显示修改输入框
      editShowEvt(e, s) {
        this.editShowInp = e.id;
        this.editName = s;
        this.$nextTick((_) => {
          this.$refs.editInput.$refs.input.focus();
        });
      },
      determineEvt() {
        editListApi({
          id: this.editShowInp,
          field: this.editName,
          val: this.$refs.editInput.nativeInputValue,
        }).then((res) => {
          this.editShowInp = null;
        });
      },
      editInpBlurEvt() {
        editListApi({
          id: this.editShowInp,
          field: this.editName,
          val: this.$refs.editInput.nativeInputValue,
        }).then((res) => {
          this.editShowInp = null;
        });
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          for (let key in this.totalRow) {
            if (column.property == key) {
              sums[index] = this.totalRow[key];
            }
          }
          if (index === 0) {
            sums[index] = "总和";
            return;
          }
          // else if (index === 1) {
          //   sums[index] = "";
          //   return;
          // } else if (index === 2) {
          //   sums[index] = "";
          //   return;
          // }
        });
        return sums;
      },
      activeEvt(res) {
        let str = "";
        if (res == 1) {
          str = "有效";
        } else {
          str = "无效";
        }
        editListApi({
          id: this.activeId,
          field: "is_active",
          val: res,
        }).then((e) => {
          this.tableData = this.tableData.map((val) => {
            if (val.id == this.activeId) {
              val.is_active = str;
            }
            return val;
          });
        });
      },
      //等级
      tableLevelEvt(res) {
        this.num = res
        this.deleteVisible = true
      },
      confirmDelete() {
        let str = "";
        switch (this.num) {
          case "1":
            str = "普通账号";
            break;
          case "2":
            str = "内部账号";
            break;
          case "5":
            str = "客户账号";
            break;
        }


        editListApi({
          id: this.activeId,
          field: "level",
          val: this.num,
        }).then((e) => {
          this.tableData = this.tableData.map((val) => {
            if (val.id == this.activeId) {
              val.level = str;
            }
            return val;
          });
          this.deleteVisible = false
        });
      },
      activeTextEvt(res) {
        this.activeId = res.id;
      },
      //有效性
      effectiveEvt(res) {
        if (res == 1) {
          this.effectiveName = "是";
        } else {
          this.effectiveName = "否";
        }
        this.okAndNo = res;
        this.data.okAndNo = res;
        // this.getList();
      },
      //等级
      levelEvt(res) {
        switch (res) {
          case "1":
            this.levelName = "普通账号";
            break;
          case "2":
            this.levelName = "内部账号";
            break;
          case "3":
            this.levelName = "客户账号";
            break;
        }
        this.adminuser = res;
        this.data.adminuser = res
        // this.getList();
      },
      //点数情况
      RechargeEvt(res) {
        switch (res) {
          case "1":
            this.RechargeName = "消费中";
            break;
          case "2":
            this.RechargeName = "消费完毕";
            break;
          case "3":
            this.RechargeName = "未充值";
            break;
        }
        this.recharge = res;
        this.data.recharge = res;

        // this.getList();
      },
      //会员情况
      vipEvt(res) {
        switch (res) {
          case "1":
            this.vipName = "会员中";
            break;
          case "2":
            this.vipName = "过期会员";
            break;
          case "3":
            this.vipName = "未入会";
            break;
        }
        this.member = res;
        this.data.member = res;

        // this.getList();
      },
      //注册来源
      registerEvt(res) {
        switch (res) {
          case "1":
            this.registerName = "Facebook";
            break;
          case "2":
            this.registerName = "Google";
            break;
          case "3":
            this.registerName = "QQ";
            break;
          case "4":
            this.registerName = "微信";
            break;
        }
        this.laiyuan = res;
        this.data.laiyuan = res;

        // this.getList();
      },
      //获取页面数据
      getList() {
        let data = {
          orField: this.orField,
          orWhere: this.order,
          remt: this.data.remtInput,
          authorId: this.data.authorIdInput,
          local: this.data.localInput,
          last_login: this.data.last_login,
          on_time: this.value2[0],
          start_time: this.value2[1],
          huiyuan_time: this.value1[0],
          huiyuan_timeend: this.value1[1],
          okAndNo: this.okAndNo,
          adminuser: this.adminuser,
          recharge: this.recharge,
          member: this.member,
          laiyuan: this.laiyuan,
          page: this.currentPage1,
          limit: this.paginationInput,
        };

        getUserListApi(data).then((res) => {
          this.tableData = res.data;
          this.paginationInput = res.limit;
          this.currentPage1 = res.page - 0;
          this.total = res.total;
          this.totalRow = res.totalRow;
          this.pagefenye = true;  //点击分页 滚动条为0
          let as = document.querySelector('.el-table__body-wrapper')
          as.scrollTop = 0
          this.imgScrollEvt(as)
        });

      },
      //清除搜索条件
      cleanUpEvt() {
        this.data = {},
          this.levelName = "等级";
        this.vipName = "会员情况";
        this.effectiveName = "有效性";
        this.RechargeName = "点数情况";
        this.registerName = "注册来源";
        this.$refs.sortTable.clearSort();
        getUserListApi().then((res) => {
          this.tableData = res.data;
          this.paginationInput = res.limit;
          this.currentPage1 = res.page - 0;
          this.total = res.total;
          this.totalRow = res.totalRow;
        });
      },
      OK_Pop() {
        this.getList()
        const form = document.getElementById('form');
        const closeBtn = document.getElementById('close-btn');
        closeBtn.addEventListener('click', function () {
          form.style.display = 'none';
        });
      },
      clearEvt1() {
        delete this.data.remtInput;
        this.dataLength--;
      },
      clearEvt2() {
        delete this.data.authorIdInput;
        this.dataLength--;
      },
      clearEvt3() {
        delete this.data.localInput;
        this.dataLength--;
      },
      clearEvt4() {
        delete this.data.last_login;
        this.dataLength--;
      },
      clearEvt5() {
        this.effectiveName = "有效性";
        this.okAndNo = 0;
        this.data.okAndNo = 0;
        if (Object.keys(this.data).length > 0) {
          delete this.data[Object.keys(this.data)
          [Object.keys(this.data).length - 1]] // 删除data对象的最后一个属性 } }
        }
      },
      clearEvt6() {
        this.levelName = "等级";
        this.adminuser = 0;
        this.data.adminuser = 0;
        if (Object.keys(this.data).length > 0) {
          delete this.data[Object.keys(this.data)
          [Object.keys(this.data).length - 1]] // 删除data对象的最后一个属性 } }
        }
      },
      clearEvt7() {
        this.RechargeName = "点数情况";
        this.recharge = 0;
        this.data.recharge = 0;
        if (Object.keys(this.data).length > 0) {
          delete this.data[Object.keys(this.data)
          [Object.keys(this.data).length - 1]] // 删除data对象的最后一个属性 } }
        }
      },
      clearEvt8() {
        this.vipName = "会员情况";
        this.member = 0;
        this.data.member = 0;
        if (Object.keys(this.data).length > 0) {
          delete this.data[Object.keys(this.data)
          [Object.keys(this.data).length - 1]] // 删除data对象的最后一个属性 } }
        }
      },
      clearEvt9() {
        this.registerName = "注册来源";
        this.laiyuan = 0;
        this.data.laiyuan = 0;
        if (Object.keys(this.data).length > 0) {
          delete this.data[Object.keys(this.data)
          [Object.keys(this.data).length - 1]] // 删除data对象的最后一个属性 } }
        }

      },
      
    },
   
    //点击X后清理数据后并更改值
    computed: {
      objectKeysLength() {
        return Object.keys(this.data).length;
      },
      dataLength() {
        return Object.keys(this.data).length;
      },
      vipNameClass() {
        if (this.vipName == '会员情况') {
          return 'red-color';
        } else {
          return '';
        }
      }
    },
    watch: {
      objectKeysLength() {
        this.dataLength = this.objectKeysLength;
      },
    

      //获取日期选择器中是否有选择日期 如果有选择日期则
      'data.value1': function (newVal, oldVal) {
        if (!newVal) {
          delete this.data.value1;
          this.dataLength--;
        }
      },
      'data.value2': function (newVal, oldVal) {
        if (!newVal) {
          delete this.data.value2;
          this.dataLength--;
        }
      },


    }
  };
</script>

<style lang="less"  scoped>
  @import url("../../../style/space.less");
  @import url("../../../style/userList.less");

  .item {
    margin-top: 10px;
  }

  /deep/.el-input__suffix {
    color: #409eff;
  }

  /deep/.el-main {
    overflow: unset !important;
  }

  .search_box {
    position: absolute;
    top: 20px;
    left: 50px;
    width: 320px;
    height: 470px;
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    justify-content: space-evenly;
    z-index: 999;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 20px 10px;
    box-shadow: 0 0 10px 1px #e5e5e5;

    /*visibility: hidden;*/
    .num_box {
      width: 127px;
      border: 1px solid #e4e3e3;
      border-radius: 3px;
      margin-top: 5px;
    }
  }

  .all_text {
    background-color: #409eff;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    padding: 5px 15px;
    border-radius: 3px;
    width: 50px;
  }

  .caoz {
    margin-top: 8px;
    display: flex;
  }

  /* .block {
    position: absolute;
    margin-top: 9px;
    top: 0;
    right: 1%;
    transition: all 0.2s ease 0.5s;
  } */
  .block{
      position: fixed;
      right: calc(100% - 99.4%);
      top: 60px;
   }

  .block1 {
    visibility: hidden;
  }

  .block1>div {
    display: none;
  }

  .clear {
    position: relative;
    height: 50px;

    span:nth-last-child(1) {
      background-color: #fff;
      border: 1px solid #e5e5e5;
      font-size: 13px;
      color: #c4c3c3;
      border-radius: 3px;
      position: absolute;
      right: 5px;
      bottom: -6px;
      padding: 0 10px;
      cursor: pointer;
    }

  }


  .demo-table-expand {
    background-color: #f2f2f2;
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 20px;
    width: 30%;
  }

  .name_box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    i {
      cursor: pointer;
      display: none;
    }
  }

  .name_box:hover>i {
    display: block;
  }

  .pagination_box {
    min-width: 500px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .num_box button {
    width: 125px;
    border: none;
    background-color: #fff;
    color: #c4c3c3;
  }



  .rowClassOne {
    background-color: #e7ecff;
  }

  .rowClassTwo {
    color: #222222;
    background-color: #1c43ce;
  }

  .rowClassThree {
    background-color: #6a88f1;
  }

  .el-dropdown-link {
    cursor: pointer;
  }

  .notes_box {
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .my-icon {
    cursor: pointer;
    width: 25px;
  }

  /deep/.el-table thead {
    font-size: 12px;
  }


  /* /deep/.el-table__header-wrapper {
    background-color: #F00 !important;
    overflow-y: scroll !important;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(1){
    color: #f00;
    position: fixed;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(2){
    color: #f00;
  }
  /deep/.el-table th.el-table__cell:nth-of-type(3){
    color: #f00;
  }
  /deep/.el-table__fixed, .el-table__fixed-right{
    overflow-y: scroll;
  } */
  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 110px;
    z-index: 111;
    width:calc(100% - 10% );
  }

  /deep/.el-table__fixed-footer-wrapper {
    display: none;
  }

  /deep/.el-badge__content.is-fixed {
    display: none;
  }

  /deep/.el-input__inner {
    color: #409eff;
    cursor: pointer;
  }

  .clear_ev {
    position: absolute;
    right: 10px;
  }

  .vip-button {
    color: #409eff !important;
  }
  .sup{
        position: absolute;
        top: -3px;
        right: -5px;
        transform: translateY(-50%) translateX(100%);
        padding: 0px 4px 0px 5px;
        background: rgb(255, 0, 0);
        border-radius: 50%;
        color: rgb(255, 255, 255);
        font-size: 12px;
        transform: scale(0.8)
  }
  .span_box{
        z-index: 888;
        width: 420px;
        height: 48px;
        border: 1px solid;
        position: fixed;
        top: 109px;
        background: #F5F7FA;
        border: none;
  }
  .span_box_two{
        z-index: 889;
        width: 125px;
        height: 47px;
        border: 1px solid;
        position: fixed;
        right: 0px;
        background: #F5F7FA;
        border: none;
        top: 110px;
  }
   /* 朝上排序样式 */
   /deep/.el-table .ascending .sort-caret.ascending{
    background-color: #f00 !important;
    background: url("../../../img/top1.png" )no-repeat  -4px -3px  !important;
    background-size: 20px 20px !important;
    width: 40px;
    height: 58px;
    z-index: 11;
  }
  /* 朝下排序样式 */
  /deep/.el-table .descending .sort-caret.descending{
    background: url("../../../img/bottom1.png" )no-repeat -5px 2px  !important;
    background-size: 20px 20px !important;
    width: 40px;
    height: 25px;
   
  }
  /deep/.el-table .descending .sort-caret.descending{
    border-top-color: #fff;
  }
  /* 朝上字体样式 */
  /deep/.el-table__header .ascending  .cell{
    color: #409EFF !important;
  }
  /* 朝下字体样式 */
  /deep/.el-table__header .descending  .cell{
    color: #409EFF !important;
  }
</style>


// WEBPACK FOOTER //
// src/user/components/author/index.vue